import React, { FunctionComponent, ReactNode } from 'react';
import LoginLayout from '../login/LoginLayout';

const RegisterLayout: FunctionComponent = ({
  children,
}: {
  children?: ReactNode;
}) => (
  <LoginLayout
    title="Create Your Free Account"
    metaDescription="Create your account with MDLIVE for free. Setting up your secure account only takes minutes. No monthly membership fee is required."
  >
    {children}
  </LoginLayout>
);

export default RegisterLayout;
